import {
  House, Wrench, Scales, Tooth, Car, HouseLine,
  ShieldCheck, ForkKnife, Barbell, CurrencyDollar,
  ShoppingCart, Books, Bug, Broom, Leaf, Bank,
  PawPrint, Bone, Sun, Crane, IconProps,
} from "@phosphor-icons/react";
import type { FC } from "react";

const iconMap: Record<string, FC<IconProps>> = {
  House, Wrench, Scales, Tooth, Car, HouseLine,
  ShieldCheck, ForkKnife, Barbell, CurrencyDollar,
  ShoppingCart, Books, Bug, Broom, Leaf, Bank,
  PawPrint, Bone, Sun, Crane,
};

export function getIndustryIcon(name: string): FC<IconProps> {
  return iconMap[name] || House;
}
